import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import reportAPI from "../../../../api/report";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import { ExceltLinePatency } from "../../functions/Report.ExportLinePatency";
import { formatLinePatency } from "../../utils/Report.Format";
import {
  BARCHART,
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEHEAD,
} from "../../../../utils/useStyle";
import DropdownReport from "../../report.dropdwn";
import { GenerateOptionsYear } from "../../../../components/functions/Functions";

const optionsYear = GenerateOptionsYear();

const DropdownFollows = ({ year, setYear }) => {
  return (
    <div>
      <DropdownReport
        title={"ปี"}
        options={optionsYear}
        value={year}
        setValue={setYear}
      />
    </div>
  );
};

const ReportFollowLinePatency = ({ userDept }) => {
  // console.log("list", list);
  // console.log("taskList", taskList);
  const [loading, setLoading] = React.useState(false);
  const [year, setYear] = React.useState({
    label: "ทุกปี",
    value: "ALL",
  });

  const [data, setData] = React.useState({
    okall: 0,
    wo: 0,
    co: 0,
    //
    count_co: 0,
    count_wo: 0,
    total_woco: 0,

    //

    wo_observe: 0,
    wo_rtpa: 0,
    //
    wo_result_open: 0,
    wo_result_wo: 0,
    wo_result_co: 0,
    //

    //

    co_observe: 0,
    co_rtpa: 0,
    //
    co_result_open: 0,
    co_result_wo: 0,
    co_result_co: 0,
    // หมวด สายติดเชื้อ

    infection_nil: 0,
    infection_bug_found: 0,
    // หมวด แขนขาบวม
    limb_edema_no: 0,
    limb_edema_yes: 0,
    //
    presence_of_dvt_no: 0,
    presence_of_dvt_yes: 0,
    presence_of_dvt_na: 0,
    //
    manag_observation: 0,
    manag_anticoagulation: 0,
    manag_catheter_removal: 0,
    // exit
    exit_site_ok: 0,
    other_exit_site: 0,
    exit_site_infection: 0,
    // line dis
    line_disledge_nil: 0,
    line_disledge_new_exit_mark_at: 0,
    complete_dislodge: 0,

    // สายรั่ว
    line_disledge_breakage_leak_port: 0,
    line_disledge_breakage_leak_port_no: 0,
    line_limb_ischemia_related_to_arterial_puncture: 0,
    line_nerve_injury_weakness_or_paresthesia: 0,

    //
    Arrow5Fr2lumenPICC: 0,
    Arrow4Fr1lumenPICC: 0,
    Bard5Fr2LumenpowerPICC: 0,
    Vygon3Fr1lumenPICC: 0,
    other_final_catheter_in: 0,
  });

  React.useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getPatencyReport({
          year: String(year?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching patency report:", error);
      }
    };
    fetchData();
  }, [year, userDept]);

  const listPatency = [
    {
      name: "patency",
      count: data?.okall,
    },
    {
      name: "withdrawal occlusion",
      count: data?.wo,
    },
    {
      name: "complete occlusion",
      count: data?.co,
    },
  ];

  const listCountPatency = [
    {
      name: "co",
      count: data?.count_co,
    },
    {
      name: "wo",
      count: data?.count_wo,
    },
  ];
  const listPatencyWO = [
    {
      name: "observe",
      count: data?.wo_observe,
    },
    {
      name: "rtPA x",
      count: data?.wo_rtpa,
    },
  ];
  const listPatencyResultWO = [
    {
      name: "open",
      count: data?.wo_result_open,
    },
    {
      name: "withdrawal occlusion",
      count: data?.wo_result_wo,
    },
    {
      name: "complete occlusion",
      count: data?.wo_result_co,
    },
  ];
  const listPatencyWoRtp = [
    {
      name: "WO + ได้รับ rtPA x",
      count: data?.wo_rtpa,
    },
  ];

  //
  const listPatencyCO = [
    {
      name: "observe",
      count: data?.co_observe,
    },
    {
      name: "rtPA x",
      count: data?.co_rtpa,
    },
  ];
  const listPatencyResultCO = [
    {
      name: "open",
      count: data?.co_result_open,
    },
    {
      name: "withdrawal occlusion",
      count: data?.co_result_wo,
    },
    {
      name: "complete occlusion",
      count: data?.co_result_co,
    },
  ];
  const listPatencyCoRtp = [
    {
      name: "CO + ได้รับ rtPA x",
      count: data?.co_rtpa,
    },
  ];
  // หมวด สายติดเชื้อ
  const listLineInfection = [
    {
      name: "None",
      count: data?.infection_nil,
    },
    {
      name: "Infection",
      count: data?.infection_bug_found,
    },
  ];
  // หมวด แขนขาบวม
  const listLineEdema = [
    {
      name: "None",
      count: data?.limb_edema_no,
    },
    {
      name: "limb edema",
      count: data?.limb_edema_yes,
    },
  ];
  const listLineEdemaYes = [
    {
      name: "No",
      count: data?.presence_of_dvt_no,
    },
    {
      name: "Yes",
      count: data?.presence_of_dvt_yes,
    },
    {
      name: "N/A",
      count: data?.presence_of_dvt_na,
    },
  ];
  const listLineEdemaManagement = [
    {
      name: "Observation",
      count: data?.manag_observation,
    },
    {
      name: "Anticoagulation",
      count: data?.manag_anticoagulation,
    },
    {
      name: "Catheter removal",
      count: data?.manag_catheter_removal,
    },
  ];
  // exit mark
  const listLineExit = [
    {
      name: "None",
      count: data?.exit_site_ok,
    },
    {
      name: "Other",
      count: data?.other_exit_site,
    },
    {
      name: "Exit site infection",
      count: data?.exit_site_infection,
    },
  ];
  // line dis
  const listLineDis = [
    {
      name: "None",
      count: data?.line_disledge_nil,
    },
    {
      name: "Displace",
      count: data?.line_disledge_new_exit_mark_at,
    },
    {
      name: "Dislodge",
      count: data?.complete_dislodge,
    },
  ];
  //  สายรั่ว breakage
  const listLineBreakage = [
    {
      name: "None",
      count: data?.line_disledge_breakage_leak_port_no,
    },
    {
      name: "Breakage/leak port",
      count: data?.line_disledge_breakage_leak_port,
    },
  ];
  const listOfSickness = [
    {
      name: "Limb ischemia",
      count: data?.line_limb_ischemia_related_to_arterial_puncture,
    },
    {
      name: "Nerve injury weakness",
      count: data?.line_nerve_injury_weakness_or_paresthesia,
    },
  ];
  //
  const listLineBreakByCat = [
    {
      name: "Arrow 5 Fr 2-lumen PICC",
      count: data?.Arrow5Fr2lumenPICC,
    },
    {
      name: "Arrow 4 Fr 1-lumen PICC",
      count: data?.Arrow4Fr1lumenPICC,
    },
    {
      name: "Bard 5 Fr 2-Lumen power PICC",
      count: data?.Bard5Fr2LumenpowerPICC,
    },
    {
      name: "Vygon 3 Fr 1-lumen PICC",
      count: data?.Vygon3Fr1lumenPICC,
    },
    {
      name: "Other",
      count: data?.other_final_catheter_in,
    },
  ];

  // eslint-disable-next-line no-unused-vars
  const CustomXAxisLabel = ({ x, y, payload }) => {
    const label = payload.value.replace(" ", "\n"); // Add newline character
    return (
      <text x={x} y={y} dy={16} textAnchor="middle">
        {label}
      </text>
    );
  };

  return (
    <div>
      {/* 1 */}
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                รายงานจำนวนครั้งที่สายตัน "{year.label}"
              </div>
              <div className={FLEXDROPDOWN}>
                <DropdownFollows year={year} setYear={setYear} />
                <ButtonExcel
                  onClick={() => {
                    ExceltLinePatency(
                      formatLinePatency(data),
                      year,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div>
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatency}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#03a9f4"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 1.5 */}
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <div className={STYLEHEAD}>
                รายงานจำนวนสายที่ตัน "{year.label}"
              </div>
              {/* <div className={FLEXDROPDOWN}>
                <DropdownFollows year={year} setYear={setYear} />
                <ButtonExcel
                  onClick={() => {
                    ExceltLinePatency(
                      formatLinePatency(data),
                      year,
                      setLoading
                    );
                  }}
                  loading={loading}
                />
              </div> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listCountPatency}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#03a9f4"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 2 */}
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  การรักษาเมื่อสายตันแบบ WO "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyWO}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#4dd0e1"
                  minPointSize={5}
                  label={true}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 3 */}
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  ผลการรักษาเมื่อสายตันแบบ WO "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyResultWO}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#4dd0e1"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 4 */}
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                ผลการรักษาสายตันแบบ WO + ได้รับ rtPA x "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyWoRtp}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#4dd0e1"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 5 */}
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                การรักษาเมื่อสายตันแบบ CO "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyCO}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#42bd41"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 6 */}
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                ผลการรักษาเมื่อสายตันแบบ CO "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyResultCO}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#42bd41"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 7 */}
      <div className={``}>
        <div className="my-20">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                ผลการรักษาสายตันแบบ CO + ได้รับ rtPA x "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listPatencyCoRtp}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#42bd41"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 8 */}
      <div className="mx-10 font-bold text-xl">Line Infection</div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  รายงานจำนวนครั้งที่เกิดภาวะสายติดเชื้อ "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineInfection}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#FFA500"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 9 */}
      <div className="mt-20 mx-10 font-bold text-xl">
        ภาวะแทรกซ้อนจากการใส่สาย
      </div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                ภาวะแทรกซ้อนจากการใส่สาย "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={`${BARCHART} relative`}>
              <BarChart
                width={700}
                height={300}
                data={listOfSickness}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#CD9B9B"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      <div className="mt-20 mx-10 font-bold text-xl">สายรั่ว</div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                รายงานจำนวนครั้งที่สายรั่ว สายแตก "{year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={`${BARCHART} relative`}>
              <BarChart
                width={700}
                height={300}
                data={listLineBreakage}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  // wordSpacing={10}
                  // writingMode={"vertical-lr"}
                  // dx={15}
                  // dy={20}
                  // minTickGap={100}
                  // axisLine={true}
                  // tick={<CustomXAxisLabel />}
                  // interval={0}
                  // height={100}
                />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#CD9B9B"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 10 */}
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div className={STYLEHEAD}>
                รายงาน การเกิดภาวะสายรั่ว สายแตก สัมพันธ์กับชนิดของสาย "
                {year.label}"
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineBreakByCat}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                {/* <XAxis dataKey="name" /> */}
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#FFCCCC"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
            <div className="flex ml-16 text-base">
              <div className="mr-7 text-center">
                Arrow 5<div>Fr 2-lumen PICC</div>
              </div>
              <div className="mr-7 text-center">
                Arrow 4<div>Fr 1-lumen PICC</div>
              </div>
              <div className="mr-7 text-center">
                Bard 5<div>Fr 2-lumen</div>
                <div>power PICC</div>
              </div>
              <div className="mr-8 text-center">
                Vygon 3<div>Fr 1-lumen PICC</div>
              </div>
              <div className="mr-6">Other</div>
            </div>
          </>
        </div>
      </div>
      {/* 11 */}
      <div className="mt-20 mx-10 font-bold text-xl">แขนขาบวม</div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  รายงานการเกิดแขนขาบวม (Catheter-related limb edema) "
                  {year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineEdema}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#f5d0fe"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 12 */}
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  กรณีแขนขาบวม มี Presence of DVT หรือไม่ "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineEdemaYes}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#f0abfc"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 13 */}
      <div className={``}>
        <div className="my-10">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  การรักษาแขนขาบวม ( Management ) ของปี "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineEdemaManagement}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#fcd34d"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 14 */}
      <div className="mt-20 mx-10 font-bold text-xl">
        ภาวะ Exit site infection
      </div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <div>
                <div className={STYLEHEAD}>
                  รายงานอุบัติการณ์การเกิดภาวะ exit site infection ของปี "
                  {year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineExit}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#a5b4fc"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
      {/* 15 */}
      <div className="mt-20 mx-10 font-bold text-xl">
        Line displacement / dislodged
      </div>
      ________________________________________________________________________________________
      <div className={``}>
        <div className="my-2">
          <>
            <div className={SCREENIPAD}>
              <> </>
              <div>
                <div className={STYLEHEAD}>
                  รายงาน Line displacement / dislodged ของปี "{year.label}"
                </div>
              </div>
              {/* <DropdownFollows year={year} setYear={setYear} /> */}
            </div>
            <div className={BARCHART}>
              <BarChart
                width={700}
                height={300}
                data={listLineDis}
                margin={{
                  top: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#fda4af"
                  minPointSize={5}
                  label={{ fill: "#111827" }}
                />
              </BarChart>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};

export default ReportFollowLinePatency;
